export default __webpack_public_path__ + "static/media/web-app-logo-128@4x.fac6aaf9.png";